<template>
  <div :class="isStories ? 'slider slider-stories' : 'slider'">
    <swiper
      class="swiper"
      :options="isStories ? swiperOptionsStories : swiperOptions"
    >
      <swiper-slide
        v-for="(slide, index) in slides"
        :key="`slide-${slide.id}-${index}`"
      >
        <div class="slide">
          <span
            v-if="isStories && getScore(slide.slug)"
            :class="getScore(slide.slug) === '0' ? 'slide-score null' : 'slide-score'">
            {{ getScore(slide.slug) }}{{ getScore(slide.slug) === '0' ? $t('labels.point') : $t('labels.points') }}
          </span>
          <figure :class="isStories && getScore(slide.slug) ? 'slide-picture done' : 'slide-picture'">
            <img
              :src="slide.thumbnail.src"
              :srcset="slide.thumbnail.src2x ? `${slide.thumbnail.src2x} 2x` : null"
              :alt="slide.thumbnail.alt"
            >
          </figure>
          <h3 class="slide-title h4" v-html="slide.title">
            <sprite
                v-if="!isStories"
                :type="'arrow-right'"
                :width="19"
                :height="12"
              />
          </h3>
          <span v-if="isStories && slide.year" class="slide-year year-s">{{ slide.year }}</span>

          <!--  Link -->
          <router-link
            :to="getTo(slide)"
            class="slide-link"
          >
            <span :class="isStories ? 'u-visually-hidden' : ''">
              {{ isStories ? slide.title : $t('home.chapters_cta') }}
            </span>
          </router-link>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import Sprite from '@/components/components/Sprite.vue';

export default {
  components: {
    Swiper,
    SwiperSlide,
    Sprite
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1.2,
        spaceBetween: 0,
        slidesOffsetAfter: 5,
        slidesOffsetBefore: 20
      },
      swiperOptionsStories: {
        slidesPerView: 2.15,
        spaceBetween: 0,
        slidesOffsetAfter: 15,
        slidesOffsetBefore: 20
      }
    };
  },
  props: {
    slides: {
      type: Array,
      required: true
    },
    loading: {
      default: false
    },
    isStories: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    completedStories() {
      return this.$store.state.user?.item?.completed;
    }
  },
  methods: {
    getTo(slide) {
      const { locale, id } = this.$route.params;
      if (this.isStories) {
        return `/${locale}/${id}/stories/${slide.slug}`;
      }
      return `/${locale}/${id}/chapters/${slide.slug}`;
    },
    getScore(slug) {
      if(!this.completedStories) return
      const story = this.completedStories.find(s => s.slug === slug);
      if (story) {
        return `${story.score}`;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.slider {
  position: relative;
  margin-left: -20px;
  width: calc(100% + 40px);

  .slide {
    display: flex;
    flex-direction: column;
    position: relative;
    width: calc(100% - 20px);
    height: 100%;

    &-picture {
      @include aspect-ratio(286,161);
      width: 100%;
      border-radius: 5px;
      overflow: hidden;

      img {
        @include position(absolute, 0 null null 0);
        @include size(100%);
        object-fit: cover;
      }
    }

    &-score {
      display: flex;
      align-items: center;
      @include position(absolute, 10px null null 10px);
      z-index: 1;
      line-height: 1.1;
      &:before {
        content: "";
        content: '';
        display: block;
        @include margin(null 7px null null);
        @include size(18px);
        z-index: 1;
        background-position: center;
        background-repeat: no-repeat;
        border: 2px solid $white;
        border-radius: 50%;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='8.252' viewBox='0 0 11 8.252'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23f6f6f6;%7D%3C/style%3E%3C/defs%3E%3Cg transform='translate(-9.514 -11.635)'%3E%3Cpath class='a' d='M13.64,17.136l-2.751-2.75L9.514,15.761l4.126,4.126,6.874-6.875L19.14,11.635Z'/%3E%3C/g%3E%3C/svg%3E");
        background-size: 10px 8px;
      }
      &.null:before {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!-- Generator: Adobe Illustrator 25.2.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E%3Csvg version='1.1' id='Calque_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 8.3 8.3' style='enable-background:new 0 0 8.3 8.3;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23F6F6F6;%7D%0A%3C/style%3E%3Cpath class='st0' d='M8.2,6.6L8.2,6.6L5.7,4.1l2.5-2.5l0,0c0.1-0.1,0.1-0.3,0-0.4c0,0,0,0,0,0L7,0.1C6.9,0,6.7,0,6.6,0.1l0,0 L4.1,2.6L1.6,0.1l0,0C1.5,0,1.4,0,1.3,0.1c0,0,0,0,0,0L0.1,1.3C0,1.4,0,1.5,0.1,1.6c0,0,0,0,0,0l0,0l2.5,2.5L0.1,6.6l0,0 C0,6.7,0,6.9,0.1,7c0,0,0,0,0,0l1.2,1.2c0.1,0.1,0.3,0.1,0.4,0c0,0,0,0,0,0l0,0l2.5-2.5l2.5,2.5l0,0c0.1,0.1,0.3,0.1,0.4,0 c0,0,0,0,0,0L8.2,7C8.3,6.9,8.3,6.7,8.2,6.6C8.2,6.6,8.2,6.6,8.2,6.6L8.2,6.6z'/%3E%3C/svg%3E%0A");
        background-size: 8px;
      }
    }

    &-title {
      @include margin(9px null null);
      display: flex;
      justify-content: space-between;
      .svg {
        fill: $secondary;
      }
      //@include line-clamp(2, 27px, false);
    }

    &-link {
      @include font('secondary', 'regular');
      color: rgba($tertiary,.5);
      font-size: rem(8.5px);
      text-transform: uppercase;
      &:after {
        content: "";
        @include size(100%);
        @include position(absolute, 0 0 0 0);
        z-index: 2;
      }
    }
  }

  &-stories {
    .slide {
      width: calc(100% - 10px);
    }
    .slide-picture {
        @include aspect-ratio(1,1);
        &.done {
          &:after {
            content: "";
            @include size(100%);
            @include position(absolute, 0 0 0 0);
            background-color: rgba($black,.3);
          }
        }
    }
    .slide-title {
      @include margin(9px null);
    }
  }
}
</style>
